import { screenSizeContext } from "@/app/store/context/screenSizesContext";
import TemporaryPin from "../shared/icons/TemporaryPin";
import { useContext } from "react";
import MasterPlanCard from "../shared/masterPlanCard";
import Image from "next/image";
import { optimizeImageUrl } from "@/app/utils/optimizeImageUrl";
import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

const InnerMasterplanPin = ({
	data,
	setActiveCard,
	activeCard,
	activeTab,
	handleInquireUnitClick,
	setActiveUnitCard,
	setActiveUnitCardData,
	setMasterplanSelectedUnit,
	optimizedImage,
}: any) => {
	const { isMobile, isIpad } = useContext(screenSizeContext);
	gsap.registerPlugin(ScrollToPlugin);
	

	return (
		<div
			className={`pin_card_container ${
				activeTab == "units" && data?.unit_type
					? "visibile"
					: activeTab == "facilities" && !data?.unit_type
					? "visibile"
					: "invisible"
			} `}
		>
			{ isIpad && (
				<div
					className={`master_plan_card_container lg:w-[25.125rem] w-[22rem] left-[50%] translate-x-[-50%] absolute z-[6] ${
						data.id == activeCard?.name ? "active z-[7]" : ""
					}`}
				>
					<div className="master-plan-card">
						<MasterPlanCard
							title={activeTab == "units" ? data?.name?.en : data?.title?.en}
							button2Text="Explore"
							button2Action={() => {
								// if (activeTab == "units") {
								setActiveUnitCard(true);
								setActiveUnitCardData(data);
								// }
							}}
							imageSrc={`${
								activeTab === "units"
									? process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL +
									  data?.media?.[0]?.media_name
									: process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL +
									  data?.image?.media_name
							}`}
							customClass="shadow-md"
							isFacilities={activeTab == "facilities"}
							isUnit={activeTab == "units"}
							hasCloseIcon
							closeAction={() => {
								setActiveCard(null);
							}}
							neigborhoodDetailsPage
							optimizedImage={optimizedImage}
						/>
					</div>
				</div>
			)}
			{(data?.top_position_mobile != 0 || data?.left_position_mobile != 0) && <div
				className={`inner_map_pin absolute z-0 ${
					data.id == activeCard?.name ? "active z-[6]" : ""
				}`}
				key={data.id}
				style={{
					top: `${
						isIpad || isMobile ? data?.top_position_mobile : data.top_position
					}%`,
					left: `${
						isIpad || isMobile ? data?.left_position_mobile : data.left_position
					}%`,
					cursor:
						activeCard === null || activeCard.event !== "click"
							? "pointer"
							: "",
				}}
				onMouseEnter={() => {
					if (!isMobile && !isIpad) {
						if (activeCard === null || activeCard.event !== "click") {
							setActiveCard({
								name: data?.id,
								event: "hover",
							});
						}
					}
				}}
				onMouseLeave={() => {
					if (!isMobile && !isIpad) {
						if (activeCard !== null && activeCard.event === "hover") {
							setActiveCard(null);
						}
					}
				}}
				onClick={() => {
					if (!isMobile && !isIpad) {
						if (activeTab == "units") {
							setActiveUnitCard(true);
							setActiveUnitCardData(data);
						} else {
							if (
								activeCard.event === "hover" ||
								(activeCard.event === "click" && activeCard.name !== data?.id)
							) {

								setActiveCard({
									name: data?.id,
									event: "click",
								});
							}
						}
					} else {						
						setActiveUnitCard(true);
						setActiveUnitCardData(data);
						// setActiveCard({
						// 	name: data?.id,
						// 	event: "click",
						// });
					}
				}}
			>
				{activeTab == "units" ? (
					<TemporaryPin />
				) : (
					<div
						className={`single_facility w-8 h-8 absolute p-2 lg:p-1 cursor-pointer rounded-full bg-white  z-[6] lg:w-12 lg:h-12  lg:py-2 lg:px-3 ${
							data.id == activeCard?.name ? "active z-[7]" : ""
						} ${activeCard?.name ? "" : "noActive"}`}
					>
						<div className="relative w-full h-full">
							<Image
								fill
								className="object-contain"
								src={
									optimizedImage
										? optimizeImageUrl(
												`${process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL}${data?.icon?.media_name}`,
												{ width: 128, quality: 75 }
											)
										: `${process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL}${data?.icon?.media_name}`
								}
								alt="zone image"
							/>
						</div>
					</div>
				)}
				{ !isIpad && (
					<div
						className={`master_plan_card_container w-[27.5rem] absolute z-[12] ${activeTab}`}
					>
						<div className="master-plan-card">
							<MasterPlanCard
								title={activeTab == "units" ? data?.name?.en : data?.title?.en}
								button2Text={"Explore"}
								button2Action={() => {
									// if (activeTab == "units") {
									setActiveUnitCard(true);
									setActiveUnitCardData(data);
									// }
								}}
								imageSrc={`${
									activeTab === "units"
									  ? process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL +
										data?.media?.sort((a: any, b : any) => a.pivot.order - b.pivot.order)[0]?.media_name
									  : process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL +
										data?.image?.media_name
								  }`}
								// imageSrc={`${
								// 	activeTab === "units"
								// 		? process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL +
								// 		  data?.media?.[0]?.media_name
								// 		: process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL +
								// 		  data?.image?.media_name
								// }`}
								customClass="shadow-md"
								isFacilities={activeTab == "facilities"}
								isUnit={activeTab == "units"}
								hasCloseIcon
								closeAction={() => {
									setActiveCard(null);
								}}
								neigborhoodDetailsPage
								optimizedImage={optimizedImage}
							/>
						</div>
					</div>
				)}
			</div>}
		</div>
	);
};

export default InnerMasterplanPin;
